
import React from 'react';
import DistrictDetails from '../components/district/DistrictPage'; 

const DistrictInfo = () => {
    return (
        <div> 
            <br/>
            <DistrictDetails />
            {/* <Agency1 /> */}
        </div>
    );
};

export default DistrictInfo;